import React, {
  useContext,
  useState,
  useEffect,
  useMemo,
  Suspense,
} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { LazyLoader } from "../routes";
// CONTEXT
import AuthContext from "../Context/Auth/AuthContext.js";
import AlertaContext from "../Context/Alerta/AlertaContext.js";
import MenuContext from "../Context/Menu/MenuContext.js";
// COMPONENTES
import Footer from "../components/Footer/Footer.js";
import Notification from "../firebaseNotifications/Notification";
import Cargando from "../components/Extra/Cargando.js";
// MATERIAL
import { styled } from "@mui/material/styles";
import {
  AppBar,
  Drawer,
  Box,
  Toolbar,
  // CssBaseline,
  alpha,
  IconButton,
  keyframes,
  Portal,
  useTheme,
} from "@mui/material";
import {
  CheckCircle,
  Error,
  Info,
  Warning,
  Close,
  WhatsApp,
} from "@mui/icons-material";
// import guardiaPng from "../assets/img/guardiaPng.png";
import Sidebar from "./Componentes/Sidebar/Sidebar";
import NavbarDesktop from "./Componentes/Navbars/NavbarDesktop.js";
import NavbarMobile from "./Componentes/Navbars/NavbarMobile.js";
import ChatPage from "../views/Chat/ChatPage.js";

// MATERIAL
// import { Alert } from "@mui/material";

const slideDown = keyframes`
  0% { transform: translateY(-100%); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

const shrinkBar = keyframes`
  0% { width: 100%; }
  100% { width: 0%; }
`;

const ToastAlert = ({ alerta, onClose }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const severityConfig = {
    success: {
      icon: <CheckCircle />,
      color: theme.palette.success.main,
      bg: isDark ? theme.palette.success.dark : theme.palette.success.light,
      iconColor: theme.palette.common.white,
      textColor: theme.palette.text.primary,
    },
    error: {
      icon: <Error />,
      color: theme.palette.error.main,
      bg: isDark ? theme.palette.error.dark : theme.palette.error.light,
      iconColor: theme.palette.common.white,
      textColor: theme.palette.text.primary,
    },
    warning: {
      icon: <Warning />,
      color: theme.palette.warning.main,
      bg: isDark ? theme.palette.warning.dark : theme.palette.warning.light,
      iconColor: theme.palette.common.white,
      textColor: theme.palette.text.primary,
    },
    info: {
      icon: <Info />,
      color: theme.palette.info.main,
      bg: isDark ? theme.palette.info.dark : theme.palette.info.light,
      iconColor: theme.palette.common.white,
      textColor: theme.palette.text.primary,
    },
  };
  if (!alerta) return null;
  const config = severityConfig[alerta.categoria] || severityConfig.info;
  return (
    <Portal>
      <Box
        onClick={onClose}
        sx={{
          top: 42,
          left: "50%",
          transform: "translateX(-50%)",
          position: "fixed",
          zIndex: theme.zIndex.modal + 2,
          animation: `${slideDown} 0.4s cubic-bezier(0.21, 1.02, 0.73, 1) forwards`,
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2.5,
            py: 1.2,
            borderRadius: 3,
            bgcolor: config.bg,
            border: `2px solid ${config.color}`,
            boxShadow: `0 8px 32px ${alpha(
              config.color,
              0.3,
            )}, 0 2px 8px rgba(0,0,0,0.12)`,
            minWidth: 280,
            maxWidth: 520,
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              boxShadow: `0 12px 40px ${alpha(
                config.color,
                0.4,
              )}, 0 4px 12px rgba(0,0,0,0.15)`,
              transform: "translateY(-1px)",
            },
            transition: "box-shadow 0.2s, transform 0.2s",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 34,
              height: 34,
              borderRadius: "50%",
              bgcolor: config.color,
              color: config.iconColor,
              flexShrink: 0,
              "& svg": { fontSize: "1.15rem" },
            }}
          >
            {config.icon}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                fontSize: "0.84rem",
                fontWeight: 600,
                color: config.textColor,
                lineHeight: 1.3,
                wordBreak: "break-word",
              }}
            >
              {alerta.msg}
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            sx={{
              color: config.color,
              p: 0.3,
              "&:hover": {
                color: config.color,
                bgcolor: alpha(config.color, 0.12),
              },
            }}
          >
            <Close sx={{ fontSize: "0.9rem" }} />
          </IconButton>
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              height: 3,
              borderRadius: "0 0 3px 3px",
              bgcolor: alpha(config.color, 0.5),
              animation: `${shrinkBar} 7s linear forwards`,
            }}
          />
        </Box>
      </Box>
    </Portal>
  );
};

// import { AddCircle } from "@mui/icons-material";
const drawerWidth = 240;

const AppBarDesktop = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  borderRight: "none",
  boxShadow: `2px 0 12px ${alpha(theme.palette.common.black, 0.06)}`,
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  borderRight: "none",
  boxShadow: `2px 0 12px ${alpha(theme.palette.common.black, 0.06)}`,
});

const DrawerDesktop = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
export default function MiniDrawer(props) {
  const { window: windowProps } = props;

  const [open, setOpen] = React.useState(false);

  const [alertaNavegador, setalertaNavegador] = useState(false);
  const [buscador, setbuscador] = useState("");
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const { usuario, socket } = useContext(AuthContext);
  const { obtenerCategorias, rows } = useContext(MenuContext);

  const { alerta, mostrarAlerta, ocultarAlerta } = useContext(AlertaContext);
  const empresaheader = localStorage.getItem("empresaheader");
  const usuarioheader = localStorage.getItem("usuarioheader");
  const rolheader = localStorage.getItem("rolheader");

  useEffect(() => {
    socket.on("server:existeRegistro", (data) => {
      mostrarAlerta(data.msg, data.alert ? data.alert : "error");
    });

    socket.on("server:error", (data) => {
      console.log({ data });

      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error",
      );
    });
    socket.on("server:notificacion", (data) => {
      mostrarAlerta(data.msg, "success");
    });

    socket.on("server:idRegistro", (data) => {
      window.open(`${data.ruta}`, "_blank");
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!rows) {
      obtenerCategorias();
    }
    const navegadorAgente = window.navigator.userAgent;

    if (
      navegadorAgente.indexOf("Chrome") > -1 ||
      navegadorAgente.indexOf("Brave") > -1
    ) {
    } else {
      setalertaNavegador(true);
    }
    // eslint-disable-next-line
  }, [rows, empresaheader, usuarioheader, rolheader, usuario, rows, socket]);

  // ADMIN Y SIDEBAR
  const tieneAcceso = (item) => {
    const tienePermiso = item.sidInfo.ver.some((permiso) =>
      usuario.rol.includes(permiso),
    );
    if (!tienePermiso) return false;
    if (item.sidInfo.bloquearAreaDepartamento === "SI") {
      return item.sidInfo.areasDepartamento.some(
        (itemArea) => itemArea === usuario.areadepartamento,
      );
    }
    return true;
  };
  const container =
    windowProps !== undefined ? () => windowProps().document.body : undefined;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const categorias = useMemo(
    () =>
      (rows || []).filter(
        (item) => item.sidInfo.tipo === "categoria" || !item.sidInfo.tipo,
      ),
    [rows],
  );

  const subCategorias = useMemo(() => {
    if (categorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "subCategoria")
      .map((item) => ({
        ...item,
        padre:
          categorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.categoria,
          )?.sidId ?? 0,
      }));
  }, [rows, categorias]);

  const subsubCategorias = useMemo(() => {
    if (subCategorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "subsubCategoria")
      .map((item) => ({
        ...item,
        padre:
          subCategorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.subcategoria,
          )?.sidId ?? 0,
      }));
  }, [rows, subCategorias]);

  const sub_sub_subCategorias = useMemo(() => {
    if (subsubCategorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "sub_sub_subCategoria")
      .map((item) => ({
        ...item,
        padre:
          subsubCategorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.subsubCategoria,
          )?.sidId ?? 0,
      }));
  }, [rows, subsubCategorias]);

  const allRows = useMemo(
    () => [
      ...sub_sub_subCategorias,
      ...subsubCategorias,
      ...subCategorias,
      ...categorias,
    ],
    [categorias, subCategorias, subsubCategorias, sub_sub_subCategorias],
  );

  const buildFullPath = (item) => {
    const parts = [];
    let current = item;
    while (current) {
      parts.unshift(current.sidInfo.path);
      if (current.padre) {
        current = allRows.find((r) => r.sidId === current.padre);
      } else {
        current = null;
      }
    }
    return (item.sidInfo.layout || "/Seguridad") + parts.join("");
  };

  if (!empresaheader) {
    return <Cargando titulo="CARGANDO HEADERS" />;
  }
  if (!usuarioheader) {
    return <Cargando titulo="CARGANDO HEADERS" />;
  }
  if (!rolheader) {
    return <Cargando titulo="CARGANDO HEADERS" />;
  }
  // initialize and destroy the PerfectScrollbar plugin
  if (!usuario) return <Cargando titulo="CARGANDO USUARIO" />;
  if (!rows) return <Cargando titulo="CARGANDO MENU" />;
  if (!socket) return <Cargando titulo="Creando conexion en tiempo real" />;

  return (
    <>
      <ToastAlert
        alerta={
          alertaNavegador
            ? {
                msg:
                  "Para obtener una mejor experiencia de uso, utilizar el navegador Chrome o Brave.",
                categoria: "warning",
              }
            : null
        }
        onClose={() => setalertaNavegador(false)}
      />
      <ToastAlert alerta={alerta} onClose={ocultarAlerta} />
      <Box sx={{ display: "flex" }}>
        {/* <CssBaseline /> */}
        <AppBar
          position="fixed"
          sx={{
            display: { xs: "block", sm: "none" },
          }}
        >
          <NavbarMobile
            buscador={buscador}
            setbuscador={setbuscador}
            handleDrawerToggle={handleDrawerToggle}
            open={open}
          />
        </AppBar>
        <AppBarDesktop
          position="fixed"
          sx={{
            display: { xs: "none", sm: "block" },
          }}
        >
          <NavbarDesktop
            buscador={buscador}
            setbuscador={setbuscador}
            handleDrawerClose={handleDrawerClose}
            handleDrawerOpen={handleDrawerOpen}
            open={open}
          />
        </AppBarDesktop>
        <Box
          component="nav"
          sx={{ flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                borderRight: "none",
                boxShadow: (theme) =>
                  `4px 0 24px ${alpha(theme.palette.common.black, 0.12)}`,
              },
            }}
          >
            <Sidebar
              buscador={buscador}
              setbuscador={setbuscador}
              open={true}
              mobile={true}
              handleDrawerToggle={handleDrawerToggle}
            />
          </Drawer>
          <DrawerDesktop
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
            }}
            open={open}
          >
            <Toolbar />
            <Sidebar
              buscador={buscador}
              setbuscador={setbuscador}
              open={open}
            />
          </DrawerDesktop>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            backgroundColor: "background.paper",
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
            }}
          >
            <Toolbar />
            <Suspense fallback={<LazyLoader />}>
              <Switch>
                {allRows
                  .filter((item) => tieneAcceso(item))
                  .map((item) => (
                    <Route
                      path={buildFullPath(item)}
                      component={item.component}
                      key={item.sidId}
                    />
                  ))}
                <Route path={"/Seguridad/Chat/*"} component={ChatPage} />
                <Redirect from="/Seguridad" to="/Seguridad/Dashboard" />
              </Switch>
            </Suspense>
          </Box>
          <Footer />
          <Notification />
          <Box
            onClick={() =>
              window.open(
                `https://wa.me/593986811138?text=Empresa: ${usuario.rucempresa}`,
                "_blank",
              )
            }
            sx={{
              position: "fixed",
              bottom: { xs: 20, sm: 28 },
              right: { xs: 16, sm: 28 },
              zIndex: 9998,
              width: { xs: 52, sm: 60 },
              height: { xs: 52, sm: 60 },
              borderRadius: "50%",
              background: (t) =>
                `linear-gradient(135deg, ${t.palette.success.main} 0%, ${t.palette.success.dark} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: (t) =>
                `0 6px 20px ${alpha(t.palette.success.main, 0.45)}`,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                transform: "scale(1.1)",
                boxShadow: (t) =>
                  `0 10px 30px ${alpha(t.palette.success.main, 0.55)}`,
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
          >
            <WhatsApp
              sx={{ color: "common.white", fontSize: { xs: 28, sm: 32 } }}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
